<template>
  <el-dialog
    title="預覽"
    :visible.sync="mIsShow"
    append-to-body
    width="592px"
    height="500px">
    <span v-html="previewingPostHtml">
    </span>
  </el-dialog>
</template>

<script>
import { IGEmbedHelper } from '@/utils/ig/IGEmbedHelper.js'
export default {
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    previewingPostHtml: {
      type: String
    }
  },
  data () {
    return {
      mIsShow: false
    }
  },
  methods: {
    close () {
      this.$emit('close')
    }
  },
  created () {
    this.mIsShow = this.isShow
  },
  watch: {
    isShow () {
      this.mIsShow = this.isShow
    },
    mIsShow () {
      if (!this.mIsShow) this.close()
      else {
        IGEmbedHelper.processEmbedPost(this.$nextTick)
      }
    }
  }
}
</script>
